import { render, staticRenderFns } from "./report-errors.vue?vue&type=template&id=12dbea9e"
import script from "./report-errors.vue?vue&type=script&lang=js"
export * from "./report-errors.vue?vue&type=script&lang=js"
import style0 from "./report-errors.vue?vue&type=style&index=0&id=12dbea9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports